import React from 'react';
import { connect } from 'react-redux'
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import { Row, Col, BackTop, Breadcrumb } from 'antd';
import { PageHeader } from 'components/header';
import { DoubleRightOutlined } from '@ant-design/icons';
import { isAuth, _setAxios, getParamTable } from '../../../../lib/Helper';
import AuthRedirect from '../../../../components/redirect/AuthRedirect'

import SearchTable from '../../../../components/search-table/SearchTable';
import SortingTableMobile from '../../../../components/sorting-table/SortingTableMobile';
import SortingTableDesktop from '../../../../components/sorting-table/SortingTableDesktop';

import Desktop from './Desktop';
import Mobile from './Mobile';

const sortFields = [{
  value: "id",
  label: "Tanggal Pembuatan",
}, {
  value: "nama",
  label: "Nama Siswa",
}, {
  value: "nisn",
  label: "NISN",
}, {
  value: "nis",
  label: "NIS",
}, {
  value: "rombel_nama",
  label: "Kelas",
}]

class Pramuka extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      values: {},
      table: {
        loading_first: false,
        loading: false,
        data: [],
        search: "",
        pagination: {
          current: 1,
          pageSize: 10,
          total: null,
        },
        sorting: [],
        filtering: {},
        detail: {},
      },
    };
  }

  fetchTable = (isNew = false) => {
    const { table } = this.state
    const params = getParamTable("default", table)
    this.fetch(params, isNew);
  }

  fetch = async (params = {}, isNew = false) => {
    this.setState({
      table: {
        ...params,
        loading_first: isMobile ? (isNew ? true : false) : false,
        loading: true
      }
    });

    params = {
      ...params,
      pagination: {
        ...params.pagination,
        current: isMobile ? (isNew ? 1 : params.pagination.current) : params.pagination.current
      }
    }
    _setAxios("kaldik-kegiatan/pramuka/siswa/table", "POST", params).then(resp => {

      if (resp.status === true) {
        let data = isNew ? [] : this.state.table.data

        let current = params.pagination.current
        this.setState({
          table: {
            ...params,
            loading_first: false,
            loading: false,
            data: isMobile ? [...data, ...resp.data.list] : resp.data.list,
            pagination: {
              ...params.pagination,
              current: isMobile ? current + 1 : current,
              total: resp.data.info.total
            }
          }
        });
      } else {
        this.setState({
          table: {
            ...params,
            loading_first: false,
            loading: false,
          }
        })
      }
    })
  };

  handleChangeSetValue = (name, value) => {
    const { values } = this.state;
    this.setForm(values, name, value)
  };

  setForm = (values, name, value) => {
    values[name] = value;

    this.setState({
      values: values,
    });
  }

  getSiswaPramukaByID = (id) => {
    _setAxios("kaldik-kegiatan/pramuka/penilaian/siswa/" + id, "GET").then(resp => {
      if (resp.status === true) {
        this.setState({
          detail: resp.data.data,
        })
      }
    })
  }

  componentDidMount() {
    this.getSiswaPramukaByID(this.props.privilege.profile_ex.siswa_id)
  }

  render() {

    const access = this.props.privilege.access["/ekstrakurikuler-pramuka/pramuka"]
    if (!isAuth(this.props.privilege) || access === undefined) {
      return <AuthRedirect />
    }
    // const action = access.action

    const { table } = this.state;

    return (
      <>
        <PageHeader
          style={{
            padding: 0
          }}
          onBack={() => window.history.back()}
          subTitle={<Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />}>
            <Breadcrumb.Item>Ekstrakurikuler & Pramuka</Breadcrumb.Item>
            <Breadcrumb.Item>Pramuka</Breadcrumb.Item>
          </Breadcrumb>}
          extra={[
            // action?.export ? <Button onClick={this.modalExport.bind(this, true)}><DownloadOutlined /> Export</Button> : null,
            // action.create ? <Button onClick={this.modalForm.bind(this, true, {})} type='primary'><PlusOutlined /> Tambah</Button> : null,
          ]}
        />
        <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
          <PageHeader
            className="site-page-header"
            title="Pramuka"
            subTitle={!isMobile ? `Data Pramuka` : ``}
          />

          <Row gutter={[16, 16]}>

            <Col xs={24} sm={12} >
              <div><b>NISN :</b> {this.state.detail ? this.state.detail.nisn : "-"}</div>
              <div><b>NIS :</b> {this.state.detail ? this.state.detail.nis : "-"}</div>
              <div><b>Siswa :</b> {this.state.detail ? this.state.detail.nama : "-"}</div>
            </Col>
            <Col xs={24} sm={12} >
              <div><b>Bantara :</b> {this.state.detail ? this.state.detail.total_bantara : "-"}</div>
              <div><b>Laksana :</b> {this.state.detail ? this.state.detail.total_laksana : "-"}</div>
            </Col>
            <Col xs={24} sm={12} >
              <br />
            </Col>

            <Col xs={24} sm={18} md={19} >
              <SearchTable table={table} fetch={this.fetch} />
            </Col>

            {/* SORTING LIST/TABLE */}
            <Col xs={24} sm={6} md={5}>
              <SortingTableMobile isFilter={true} table={table} fetch={this.fetch} sortFields={sortFields} />
              <SortingTableDesktop table={table} fetch={this.fetch} sortFields={sortFields} />
            </Col>

            {/* LIST/TABLE DATA */}
            <Col xs={24}>
              <BrowserView>
                <Desktop
                  access={access}
                  state={this.state}
                  fetch={this.fetch}
                  fetchTable={this.fetchTable}
                />
              </BrowserView>
              <MobileView>
                <Mobile
                  access={access}
                  state={this.state}
                  fetch={this.fetch}
                  fetchTable={this.fetchTable}
                />
              </MobileView>
            </Col>

          </Row>
        </div>
        <BackTop />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    privilege: state.privilege,
  }
}

export default connect(mapStateToProps)(Pramuka);
